import {
  Breadcrumb,
  Button,
  Card,
  Col,
  Divider,
  Layout,
  Row,
  Skeleton,
  Switch,
  Tabs,
  notification,
  theme,
} from "antd";
import { useCallback, useEffect, useState } from "react";
import {
  apiSystemAcquirerPriority,
  apiUpdateSystemAcquirerPriority,
} from "../../../../api/systemConfigs";
import AcquirerPriorityList from "../../../common/AcquirerPriorityList/AcquirerPriorityList";
import "./SystemConfigs.scss";

const { Content } = Layout;

const SystemConfigs = () => {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const [loading, setLoading] = useState(true);
  const [loaded, setLoaded] = useState(false);
  const [saving, setSaving] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [acquirers, setAcquirers] = useState([]);
  const [entries, setEntries] = useState({});
  const [prefer3ds, setPrefer3ds] = useState(false);

  const acquirerLabels = Object.fromEntries(acquirers.map((item) => [item.code, item.label]));

  const fetchPriority = useCallback(async () => {
    setLoading(true);
    setLoaded(false);
    try {
      const data = await apiSystemAcquirerPriority();
      setPaymentMethods(data.payment_methods || []);
      setAcquirers(data.acquirers || []);
      setEntries(data.entries || {});
      setPrefer3ds(Boolean(data.prefer_3ds));
      setLoaded(true);
    } catch (error) {
      notification.error({
        message: "Erro",
        description: "Erro ao carregar as configurações do sistema.",
        placement: "topRight",
      });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPriority();
  }, [fetchPriority]);

  const handleReorder = (paymentMethod, order) => {
    setEntries((current) => ({ ...current, [paymentMethod]: order }));
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const data = await apiUpdateSystemAcquirerPriority({ entries, prefer_3ds: prefer3ds });
      setEntries(data.entries || {});
      setPrefer3ds(Boolean(data.prefer_3ds));
      notification.success({
        message: "Sucesso",
        description: "Prioridade de adquirentes salva.",
        placement: "topRight",
      });
    } catch (error) {
      notification.error({
        message: "Erro",
        description: "Erro ao salvar a prioridade de adquirentes.",
        placement: "topRight",
      });
    } finally {
      setSaving(false);
    }
  };

  const priorityTab = loading ? (
    <Skeleton active />
  ) : (
    <>
      <p className="config-hint">
        Arraste para definir a ordem em que os adquirentes são tentados em cada meio de pagamento. O
        primeiro da lista é o preferido; se o vendedor não estiver cadastrado nele, o próximo é
        usado.
      </p>
      <Card size="small" className="config-3ds">
        <div className="config-3ds-row">
          <div>
            <div className="config-3ds-title">Preferir 3DS</div>
            <div className="config-3ds-hint">
              Ativa a autenticação 3D Secure em pagamentos com cartão de crédito para todos os
              vendedores, mesmo os que não ativaram a opção. Adquirentes sem suporte a 3DS seguem o
              fluxo normal.
            </div>
          </div>
          <Switch checked={prefer3ds} disabled={saving} onChange={setPrefer3ds} />
        </div>
      </Card>
      <Row gutter={[16, 16]}>
        {paymentMethods.map((method) => (
          <Col key={method.code} xs={24} md={12} xl={8}>
            <Card title={method.label} size="small">
              <AcquirerPriorityList
                value={entries[method.code] || []}
                labels={acquirerLabels}
                disabled={saving}
                onChange={(order) => handleReorder(method.code, order)}
              />
            </Card>
          </Col>
        ))}
      </Row>
      {loaded && (
        <div className="config-actions">
          <Button type="primary" loading={saving} onClick={handleSave}>
            Salvar
          </Button>
        </div>
      )}
    </>
  );

  return (
    <div className="SystemConfigs">
      <Layout style={{ padding: "1.25rem" }}>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h2 className="title-page">Configurações do sistema</h2>
          </div>
          <Divider />
          <Breadcrumb.Item>Sistema</Breadcrumb.Item>
          <Breadcrumb.Item>Configurações</Breadcrumb.Item>
        </Breadcrumb>
        <Content
          style={{
            padding: 24,
            margin: 0,
            minHeight: 280,
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
          }}
        >
          <Tabs
            defaultActiveKey="acquirer-priority"
            items={[
              {
                key: "acquirer-priority",
                label: "Prioridade de Adquirentes",
                children: priorityTab,
              },
            ]}
          />
        </Content>
      </Layout>
    </div>
  );
};

export default SystemConfigs;
